
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#003653","fill-rule":"evenodd","d":"M45.5 10c2.485 0 4.5 1.79 4.5 4v36c0 2.21-2.015 4-4.5 4h-27c-2.485 0-4.5-1.79-4.5-4V14c0-2.21 2.015-4 4.5-4h27zm.214 2H18.286c-1.172 0-2.139.772-2.27 1.767L16 14v36c0 1.026.882 1.871 2.02 1.987l.266.013h27.428c1.172 0 2.139-.772 2.27-1.767L48 50V14c0-1.026-.882-1.871-2.02-1.987L45.715 12zM42.5 16a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM32 20c7.732 0 14 6.268 14 14s-6.268 14-14 14-14-6.268-14-14 6.268-14 14-14zm0 2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.428 6.502a1 1 0 01.101 1.277l-.117.137-.868.849a1.778 1.778 0 00.008 2.514 3.853 3.853 0 01.28 5.156l-.231.26-1.027 1.06a1 1 0 01-1.55-1.253l.114-.14 1.028-1.059c.648-.668.693-1.699.141-2.417l-.165-.188a3.779 3.779 0 01-.248-5.088l.27-.294.85-.83a1 1 0 011.414.016zm6 0a1 1 0 01.101 1.277l-.117.137-.868.849a1.778 1.778 0 00.008 2.514 3.853 3.853 0 01.28 5.156l-.231.26-1.027 1.06a1 1 0 01-1.55-1.253l.114-.14 1.028-1.059c.648-.668.693-1.699.141-2.417l-.165-.188a3.779 3.779 0 01-.248-5.088l.27-.294.85-.83a1 1 0 011.414.016zM25 16a1 1 0 010 2h-4a1 1 0 010-2h4z"}})])
          )
        }
      }
    